import CustomProvider from 'components/CustomProvider';
import Typography from '@alltrails/shared/denali/components/Typography';
import Link from '@alltrails/shared/denali/components/Link';
import { FormattedMessage } from '@alltrails/shared/react-intl';
import useLanguageRegionCode from '@alltrails/shared/hooks/useLanguageRegionCode';
import getHelpCenterUrl from '@alltrails/shared/utils/constants/helpCenterUrl';
import * as styles from './DeleteAccountContent.module.scss';

const Bold = (chunks: React.ReactNode) => (
  <Typography component="span" variant="text100bold">
    {chunks}
  </Typography>
);

const AutoRenewLink = (chunks: React.ReactNode) => {
  const languageRegionCode = useLanguageRegionCode();
  return (
    <Link href={getHelpCenterUrl(languageRegionCode, 37208391282196)} target="_blank" rel="noreferrer">
      {chunks}
    </Link>
  );
};

const DeleteAccountContentInner = () => (
  <>
    <Typography component="h1" variant="heading400" mb="16">
      <FormattedMessage defaultMessage="Delete your account?" />
    </Typography>

    <Typography component="p" variant="paragraph100">
      <FormattedMessage defaultMessage="We'd be sad to see you go, but we're here to help. Here's how it works:" />
    </Typography>

    <ul className={styles.list}>
      <li>
        <Typography variant="paragraph100">
          <FormattedMessage defaultMessage="When you select 'Start deletion,' you'll be signed out and sent an email to confirm the deletion." />
        </Typography>
      </li>
      <li>
        <Typography variant="text100bold">
          <FormattedMessage defaultMessage="For security reasons, your account won't be deleted until you confirm through that email." />
        </Typography>
      </li>
      <li>
        <Typography variant="paragraph100">
          <FormattedMessage defaultMessage="Once your account is deleted, this can't be undone. You'll lose access to your activities, photos, reviews, and all other account data." />
        </Typography>
      </li>
      <li>
        <Typography variant="paragraph100">
          <FormattedMessage
            defaultMessage="<b>Peak and Plus members:</b> Before starting, be sure to <link>cancel your subscription</link>. We can't delete an account with an active subscription."
            values={{ b: Bold, link: AutoRenewLink }}
          />
        </Typography>
      </li>
    </ul>

    <hr className={styles.hr} />
    <Typography component="p" variant="paragraph100">
      <FormattedMessage defaultMessage="Before you go, would you like to share any feedback with us?" />
    </Typography>
  </>
);

export default function DeleteAccountContent() {
  return (
    <CustomProvider>
      <DeleteAccountContentInner />
    </CustomProvider>
  );
}
